import { render, staticRenderFns } from "./DocumentManageNumberInput.vue?vue&type=template&id=e8a34c00&scoped=true&"
import script from "./DocumentManageNumberInput.vue?vue&type=script&lang=ts&"
export * from "./DocumentManageNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentManageNumberInput.vue?vue&type=style&index=0&id=e8a34c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a34c00",
  null
  
)

export default component.exports